'use client'
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicLink, PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { useState } from "react";

/**
 * @typedef {import("@prismicio/client").Content.GallerySlice} GallerySlice
 * @typedef {import("@prismicio/react").SliceComponentProps<GallerySlice>} GalleryProps
 * @type {import("react").FC<GalleryProps>}
 */
const Gallery = ({ slice, index, slices }) => {
  const isLast = Array.isArray(slices) && index === slices.length - 1;
  const fallbackAlt = "Image de contenu";

  const [hoveredImage, setHoveredImage] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleMouseMove = (e) => {
    setMousePosition({ x: e.clientX, y: e.clientY });
  };

  const handleMouseEnter = (imageData, index) => {
    setHoveredImage(imageData);
    setCurrentIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredImage(null);
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-white w-screen overflow-hidden`}
    >
     <div className={`min-h-screen ${isLast ? "md:pb-10" : ""} flex justify-center w-full`}>
       {isFilled.group(slice.primary.galleries) && (
         <div className="w-full my-auto">
           {slice.primary.galleries.map((item, index) => (
             <div key={index}>
               {isFilled.link(item.gallery) && isFilled.richText(item.gallery.data?.preview_name) && (
                 <div 
                   className="group w-full transition-all duration-200 hover:bg-black block py-2 md:py-4"
                   onMouseMove={handleMouseMove}
                   onMouseEnter={() => handleMouseEnter(item.gallery.data.img, index)}
                   onMouseLeave={handleMouseLeave}
                 >
                   <PrismicLink field={item.gallery} className="block w-full">
                     <PrismicRichText 
                       field={item.gallery.data.preview_name} 
                       components={{
                         paragraph: ({ children }) => <p className="justify-center flex font-neue-haas font-bold uppercase text-2xl md:text-7xl group-hover:text-white transition-colors duration-300">{children}</p>
                       }}
                     />
                   </PrismicLink>
                 </div>
               )}
             </div>
           ))}
         </div>
       )}
     </div>

     {/* Image qui suit la souris */}
     {hoveredImage && isFilled.image(hoveredImage) && (
       <div 
         className="fixed pointer-events-none z-50 transition-opacity duration-200"
         style={{
           left: mousePosition.x + 250,
           top: mousePosition.y - 0,
           transform: 'translate(-50%, -50%)'
         }}
       >
         <PrismicNextImage 
           field={hoveredImage} 
           alt={hoveredImage?.alt || fallbackAlt}
           className="w-100 max-w-70 h-full object-contain"
         />
       </div>
     )}
    </section>
  );
};

export default Gallery;
